export default "__VITE_ASSET__B3EA6D7G__"